import React from 'react';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';
import { NamedLink } from '../../components';

import StepList from '../SectionSteps/StepList';
import { CLUB_PROOF, CLUB_FEATURES, CLUB_MONEY, CLUB_STEPS, CLUB_CLOSER } from '../clubPage';
import gem from '../salesPage.module.css';
import css from './SectionClub.module.css';

const Check = () => (
  <svg
    className={gem.check}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="9" cy="9" r="9" className={gem.checkDisc} />
    <path
      d="M5 9.2 7.6 11.8 13 6.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * FairwayBid: Die Golfanlagenseite.
 *
 * Eine Golfanlage zahlt hier nichts – sie muss also nicht vom Preis
 * überzeugt werden, sondern davon, dass dieser Weg besser ist als der
 * gewohnte. Deshalb folgt die Seite dem Ablauf einer Beschaffung: was Sie
 * davon haben, was es finanziell bedeutet, wie es abläuft.
 *
 * Der Finanzteil steht auf dunklem Grund. Nicht als Verzierung: Er ist die
 * Pointe der Seite, und ein Clubmanager, der nur überfliegt, bleibt genau
 * dort hängen.
 *
 * Überschrift und Einleitung kommen aus der Console, die Argumente stehen in
 * src/fairwaybid/clubPage.js. Dort steht auch, warum sie ohne erfundene
 * Sparquoten auskommen.
 */
const SectionClub = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <span className={gem.eyebrow}>Für Golfanlagen</span>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <Field data={description} className={gem.intro} options={fieldOptions} />
          <NamedLink name="SignupPage" className={gem.heroCta}>
            Kostenlos registrieren
          </NamedLink>
        </header>
      ) : null}

      <div className={gem.wrap}>
        <dl className={gem.proof}>
          {CLUB_PROOF.map(punkt => (
            <div key={punkt.label} className={gem.proofItem}>
              <dt className={gem.proofValue}>{punkt.value}</dt>
              <dd className={gem.proofLabel}>
                {punkt.label}
                <span className={gem.proofNote}>{punkt.note}</span>
              </dd>
            </div>
          ))}
        </dl>

        <h3 className={gem.blockTitle}>Was Sie davon haben</h3>
        <div className={gem.features}>
          {CLUB_FEATURES.map(f => (
            <article key={f.key} className={gem.feature}>
              <Check />
              <div>
                <h4 className={gem.featureHeadline}>{f.headline}</h4>
                <p className={gem.featureText}>{f.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/*
        Der Finanzteil laeuft ueber die volle Breite und auf dunklem Grund -
        er ist die Pointe, und wer die Seite nur ueberfliegt, soll genau hier
        haengen bleiben.
      */}
      <div className={css.money}>
        <div className={css.moneyInner}>
          <h3 className={css.moneyTitle}>Was das finanziell bedeutet</h3>
          <p className={css.moneyLead}>
            Wir versprechen keine Sparquote – wie viel eine Anlage spart, hängt von ihr ab. Was
            FairwayBid verändert, ist die Ausgangslage:
          </p>
          <ol className={css.moneyList}>
            {CLUB_MONEY.map((m, i) => (
              <li key={m.headline} className={css.moneyItem}>
                <span className={css.moneyNum} aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h4 className={css.moneyHeadline}>{m.headline}</h4>
                  <p className={css.moneyText}>{m.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div className={gem.wrap}>
        <h3 className={gem.blockTitle}>So läuft es ab</h3>
        <StepList steps={CLUB_STEPS} className={gem.steps} />

        <aside className={css.closer}>
          <h3 className={css.closerHeadline}>{CLUB_CLOSER.headline}</h3>
          <p className={css.closerText}>{CLUB_CLOSER.text}</p>
          <NamedLink name="SignupPage" className={gem.heroCta}>
            {CLUB_CLOSER.cta}
          </NamedLink>
        </aside>
      </div>
    </SectionContainer>
  );
};

export default SectionClub;
